// 之前的工具类函数都是写在一个文件下的
// 重构后拆了文件，新写函数名的时候需要注意不要重名
import * as bridgeApi from './bridge';
import xss from './xss';
export const bridge = bridgeApi;
export * from './file';
export * from './toast';
export * from './url';
export * from './value';
export * from './xss';
export function filterXSS(value) {
    return xss(value);
}
